import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { ConfirmDialog } from '../../dialog/confirm/confirm.dialog';
import { ParentEvents } from '../../../utils/parent-events.service';
import { UserInterface } from '../../../../core';

@Component({
    selector: 'thr-header-operative',
    templateUrl: './header-operative.component.html',
    styleUrls: ['./header-operative.component.scss'],
})
export class HeaderOperativeComponent {
    @Input()
    agent: UserInterface;

    @Input()
    showBack = false;

    @Output()
    back: EventEmitter<boolean> = new EventEmitter();

    constructor(public dialog: MatDialog, private parentEvents: ParentEvents) {}

    onBack() {
        this.back.emit(true);
    }

    onExit() {
        const dialogRef = this.dialog.open(ConfirmDialog, {
            data: { text: 'dialog.confirm-exit' },
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result) {
                this.parentEvents.cancel();
            }
        });
    }
}
